import {useEffect} from 'react';

import {useLocation} from 'react-router-dom';

import useProjects from '../../providers/useProjects';

// This hook automatically opens project creation modal if location.state.isProjectCreationModalOpen
// This is useful because when user logs to a connector using 0auth, he leaves the site. We want to redirect him to the initial page (folders)
// and keep the modal open + connector selected, to improve UX.
const useOpenConnectionCreationModalAfterExternalConnectionAuthRedirection = () => {
  const {connectors, setConnector, setCreateConnectionFormStep, setCreateProjectModalOpen} = useProjects();
  const location = useLocation();

  useEffect(() => {
    const shouldOpen = location.state?.isProjectCreationModalOpen;
    const connectorId = location.state?.connectorId;

    if (shouldOpen) {
      setCreateProjectModalOpen(true);
      const connectorToSelect = connectors.find(c => c.id === connectorId);
      if (connectorToSelect) setConnector(connectorToSelect);
      setCreateConnectionFormStep(1);
    }
  }, [connectors]);
};

export default useOpenConnectionCreationModalAfterExternalConnectionAuthRedirection;
